// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__bDIXt","form":"styles_form__fbhIR"};